"use client";

import React from "react";
import { LinkedInIcon } from "./icons/SocialIcons";

export default function Newsletter() {
  return (
    <div className="space-y-4">
      <form
        action="https://agency.us20.list-manage.com/subscribe/post"
        method="POST"
        className="flex flex-col sm:flex-row gap-4"
      >
        <input type="hidden" name="u" value="b61fffd65635b4ada56c6316f" />
        <input type="hidden" name="id" value="4b3c1b9c49" />

        <div className="flex-1">
          <label htmlFor="MERGE0" className="sr-only">
            Email Address
          </label>
          <input
            type="email"
            name="MERGE0"
            id="MERGE0"
            className="w-full px-4 py-2.5 rounded-lg bg-white/50 dark:bg-dark/50 
                     border border-gray-light/20 dark:border-gray-dark/20
                     focus:outline-none focus:ring-2 focus:ring-dark dark:focus:ring-white"
            placeholder="Enter your email..."
            required
          />
        </div>

        <button
          type="submit"
          className="px-6 py-2.5 rounded-full border-2 border-current group relative inline-block overflow-hidden text-center hover:scale-105 transition-transform duration-200"
        >
          Sign Up!
        </button>
      </form>

      <a
        href="https://www.linkedin.com/newsletters/7287872558081671168/"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-2 py-1 rounded-lg bg-surface-light dark:bg-surface-dark hover:bg-surface-light/80 dark:hover:bg-surface-dark/80 transition-colors"
      >
        <LinkedInIcon />
        <div className="text-sm text-text-muted-light dark:text-text-muted-dark">
          Or sign up on LinkedIn →
        </div>
      </a>
    </div>
  );
}
